import { Component,
         Output,
         EventEmitter,
         ViewChild,
         AfterViewInit,
         ChangeDetectorRef}               from '@angular/core';
import { MatDialog,
         MatSnackBar }                    from '@angular/material';
import { MonitoringService }              from './../shared/monitoring.service';
import { ReportingService }               from './../shared/reporting.service';
import { CompanyService }                 from './../shared/company.service';
import { TableColumn,
         TableColumnType }                from './../common/table-column';
import { ISortableFilter,
         SortDirection }                  from './../common/sortable-filter';
import { MonitoringSortableFilter,
         RecipeSortableFilter }           from './monitoring-sortable-filter';
import { DynamicReportFilter }            from './dynamic-report-filter';
import { DynamicReportItem }              from './dynamic-report-item';
import { FormArray,
         FormBuilder,
         FormControl,
         FormGroup }                      from '@angular/forms';
import { ReceiptDialogComponent }         from './../receipt-dialog/receipt-dialog.component';
import { Observable }                     from 'rxjs/Observable';
import { toLocalTime,
         toLocalTimeShort,
         toNetParameterDate }             from './../common/functions';
import { Globals }                        from './../common/globals';

@Component({
  selector: 'sa-monitoring',
  template: require('./monitoring.component.html'),
  styles: [require('./monitoring.component.scss')]
})
export class MonitoringComponent implements AfterViewInit {

  @Output() dataSyncColumns: Array<TableColumn>;

  @Output() dataPosColumns: Array<TableColumn>;

  @Output() dynamicReportColumns: Array<TableColumn>;

  @Output() recipeListColumns: Array<TableColumn>;

  @Output() dataSyncfilter = new MonitoringSortableFilter('dateCreated', SortDirection.desc);

  @Output() dataPosfilter = new MonitoringSortableFilter('kitchenName', SortDirection.asc);

  @Output() recipeListFilter = new RecipeSortableFilter('recCreated', SortDirection.asc);

  @Output() dynamicReportfilter = new DynamicReportFilter(null);

  @Output() dataSyncPerformSearch = new EventEmitter();

  @Output() dataPosPerformSearch = new EventEmitter();

  @Output() recipeListPerformSearch = new EventEmitter();

  @Output() dynamicReportSearchEvent = new EventEmitter();

  @ViewChild('dataPosList') dataPosListGrid;

  @ViewChild('dataSyncList') dataSyncListGrid;

  @ViewChild('recipeList') recipeListGrid;

  reportFormInputs: Array<any>;

  reportForm: FormGroup;

  showPosData = false;

  showSyncData = false;

  showBillReport = false;

  companies = [];

  docTypeNames: any;

  typeOptions: Array<any>;

  public defaultDate: string;

  public getDataSyncCallback: Function;
  public getPageDataSyncCallback: Function;

  public getDataPosCallback: Function;
  public getPageDataPosCallback: Function;

  // Dynamic reports
  public getReportCallbackFunction: Function;
  public getReportPageCallbackFunction: Function;

  public getRecipeListCallback: Function;

  public getPageRecipeListCallback: Function;

  // public reportsReady = false;

  public dynamicReportfilterReady = false;

  public companiesReady = false;

  public reports: Array<DynamicReportItem>;

  public notSelectedReport: DynamicReportItem = new DynamicReportItem();

  public selectedReport: any = this.notSelectedReport;

  public notSelectedReceipeType = {value: -1, text: 'Vše'};

  constructor(
      private apiService: MonitoringService,
      private reportingService: ReportingService,
      private companyService: CompanyService,
      public receiptDialog: MatDialog,
      private reportFormBuilder: FormBuilder,
      private snackbar: MatSnackBar,
      private changeDetectionRef: ChangeDetectorRef,
      private globals: Globals
      ) {
    this.getDataSyncCallback = this.getDataSyncCallbackInner.bind(this);
    this.getPageDataSyncCallback = this.getDataSyncPageCallbackInner.bind(this);

    this.getDataPosCallback = this.getDataPosCallbackInner.bind(this);
    this.getPageDataPosCallback = this.getDataPosPageCallbackInner.bind(this);

    this.getReportCallbackFunction = this.getReportCallbackInner.bind(this);
    this.getReportPageCallbackFunction = this.getReportPageCallbackInner.bind(this);

    this.getRecipeListCallback = this.getRecipeListCallbackInner.bind(this);
    this.getPageRecipeListCallback = this.getPageRecipeListCallbackInner.bind(this);

    this.dataSyncColumns = [
      new TableColumn(TableColumnType.Text, 'errorType', 'Stav', 5, true, null, false, null,
            (val) => {
              let severity = 'monitoring severity-' + val;
              return '<i class=\"material-icons ' + severity + '\"></i>';
            }),
      new TableColumn(TableColumnType.Text, 'source', 'Zdroj', 10),
      new TableColumn(TableColumnType.Text, 'target', 'Cíl', 10),
      new TableColumn(TableColumnType.Text, 'dateCreated', 'Čas', 15, true, null, false,
            (date) => {
              return toLocalTime(new Date(date));
            }),
      new TableColumn(TableColumnType.Text, 'output', 'Log', 60, false, null, null, null,
            (val) => {
              return '<code class=\"log\">' + val.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</code>';
            }),
      new TableColumn(TableColumnType.None, 'output', 'Stáhnout', 10, false, null, null, null,
            (val) => {
              return '<i class=\"material-icons\">save</i>';
            },
            (val) => {
              return this.clickToDownload(val);
            })
    ];

    this.dataPosColumns = [
      new TableColumn(TableColumnType.Text, 'loggedIn', 'Přihlášen', 5, true, null, false, null,
            (val) => {
              let severity = 'monitoring loggedIn-' + val;
              return '<i class=\"material-icons ' + severity + '\"></i>';
            }),
      new TableColumn(TableColumnType.Text, 'kitchenName', 'Kuchyňka', 10),
      new TableColumn(TableColumnType.Text, 'trainDescr', 'Spoj', 50),
      new TableColumn(TableColumnType.Text, 'userId', 'ID stevarda', 5),
      new TableColumn(TableColumnType.Text, 'ldaplogin', 'Login stevarda', 10),
      new TableColumn(TableColumnType.Text, 'deviceId', 'ID zařízení', 10),
      new TableColumn(TableColumnType.Text, 'dateCreated', 'Čas', 15, true, null, false,
      (date) => {
        return toLocalTime(new Date(date));
      }),
      new TableColumn(TableColumnType.Text, 'monitoringPosLogUID', 'MonitoringPosLogUID', 10, false, null, true)
    ];

    this.dynamicReportColumns = [];

    this.recipeListColumns = [
      new TableColumn(TableColumnType.DateTime2, 'documentDate', 'Vytvořen', 150, true, 150, false, null, (date) => {
        return toLocalTimeShort(new Date(date + 'Z'));
      }),
      new TableColumn(TableColumnType.Number, 'documentNumber', 'Číslo dokladu', 150),
      new TableColumn(TableColumnType.Number, 'documentType', 'Typ dokladu', 150, true, 150, false, null, (i) => this.DocTypeName(i)),
      new TableColumn(TableColumnType.Text, 'sellerNumber', 'Číslo baristy', 80),
      new TableColumn(TableColumnType.Text, 'totalValue', 'Hodnota', 80)
      // ,
      // new TableColumn(TableColumnType.None, 'bill', 'Zobrazit doklad', 80, false, 80, false, null, (val) => {
      //   return '<i class=\"material-icons\">receipt</i>';
      //  })
    ];

    this.docTypeNames = {
        '0': 'Prodej',
        '12': 'Uzávěrka'
      };

    this.typeOptions = [this.notSelectedReceipeType, {value: 0, text: 'Prodej'}, {value: 12, text: 'Uzávěrka'}];
    this.recipeListFilter.documentType = this.notSelectedReceipeType.value;

    reportingService.listReports().subscribe(res => {
      this.reports = res.sort((a,b) => {
        let aName = a.name.toUpperCase();
        let bName = b.name.toUpperCase();

        if (aName > bName) {
          return 1;
        }

        if (aName < bName) {
          return -1;
        }

        return 0;
      });
      // this.reportsReady = true;
    });

    this.defaultDate = new Date().toISOString();
  }

  public DocTypeName(docType: number): string {
    let type = String(docType);
    return this.docTypeNames[type] || type;
  }

  public DocTypeNames(): Array<any> {
    let names = this.docTypeNames, keys = Object.keys(names);
    return keys.map(function(k) { return {docType: k, typeName: names[k]}; });
  }

  public showReceiptDetail(model) {
    let dialogRef = this.receiptDialog.open(ReceiptDialogComponent);
    dialogRef.componentInstance.model = model;
    this.apiService.getReceiptDetail(model.recUid, model.slotId)
      .subscribe(m => {
        if (m !== null && m.text != null) {
          model.receiptText = m.text;
        } else {
          model.receiptText = 'Účtenka neexistuje.';
        }
    });
  }

  public reportChanged(event) {

    this.dynamicReportfilterReady = false;
    if (!event || !event.parameters) {
      this.dynamicReportfilter.Parameters = [];
      this.reportForm = null;
      this.dynamicReportColumns = [];
      this.changeDetectionRef.detectChanges();
      return;
    }
    let group = {};

    event.parameters.parameter.forEach(element => {
      group[element.name] = new FormControl(element.value || '');
      if (element.type === 'date') {
        let d: Date = undefined;
        group[element.name].setValue(d);
      }
    });

    this.reportForm = new FormGroup(group);
    this.changeDetectionRef.detectChanges();
  }

  private clickToDownload(val) {
    (<any>window).location = this.apiService.getDataLogFilePath(val.monitoringDataLogUID);
  }

  public onReportSelectedSubmit(): void {

      this.dynamicReportfilter.Parameters = [];
      this.dynamicReportfilter.ReportName = this.selectedReport.name;

      let report = <DynamicReportItem>this.selectedReport;
      this.dynamicReportColumns = [];
      report.columns.column.forEach(c => {
        this.dynamicReportColumns.push(new TableColumn(TableColumnType.Text, c.name, c.displayName));
      });

      this.selectedReport.parameters.parameter.forEach(element => {
        let control = <FormArray>this.reportForm.controls[element.name];
        this.dynamicReportfilter.Parameters.push({ 'Name': element.name, 'Value': control.value });
      });

      this.dynamicReportfilterReady = true;

      this.dynamicReportSearchEvent.emit(this.dynamicReportfilter);
  }

  private getDataSyncCallbackInner(filter: ISortableFilter) {
    return this.apiService.getDataLog(filter);
  }

  private getDataSyncPageCallbackInner(filter: ISortableFilter) {
    return this.apiService.getDataLog(filter);
  }

  private getDataPosCallbackInner(filter: ISortableFilter) {
    return this.apiService.getPosLog(filter);
  }

  private getDataPosPageCallbackInner(filter: ISortableFilter) {
    return this.apiService.getPosLog(filter);
  }

  private getReportCallbackInner(filter: DynamicReportFilter) {
    if (this.dynamicReportfilterReady) {
      return this.reportingService.runReport(filter);
    }
    return Observable.from(Array<any>());
  }

  private getReportPageCallbackInner(filter: DynamicReportFilter) {
    if (this.dynamicReportfilterReady) {
      return this.reportingService.runReport(filter);
    }
    return Observable.from(Array<any>());
  }

  private getRecipeListCallbackInner(filter: ISortableFilter) {
    return this.apiService.getReceiptList(filter);
  }

  private getPageRecipeListCallbackInner(filter: ISortableFilter) {
    return this.apiService.getReceiptList(filter);
  }

  private runBillSearch() {

    if (this.recipeListFilter.dateFromValue === null ||
       this.recipeListFilter.dateToValue === null ||
       this.recipeListFilter.companyUid === null) {
          this.snackbar.open('Pro vyhledání účtenky zadejte prosím všechny povinné položky', 'Zavřít', {duration: 4000});
          return;
       }

    if (this.recipeListFilter.dateFromValue > this.recipeListFilter.dateToValue) {
      this.snackbar.open('Datum vytvoření OD je vyšší než datum vytvoření DO.', 'Zavřít', {duration: 4000});
      return;
    }

    this.recipeListFilter.dateFrom = toNetParameterDate(this.recipeListFilter.dateFromValue);
    this.recipeListFilter.dateTo = toNetParameterDate(this.recipeListFilter.dateToValue);
    this.recipeListPerformSearch.emit(this.recipeListFilter);
  }

  public tabSelectChange(event) {
    if (event.index === 1 && !this.showPosData) {
        this.showPosData = true;
        this.dataPosListGrid.getPage(1);
      return;
    }
    if (event.index === 2 && !this.showSyncData) {
        this.showSyncData = true;
        this.dataSyncListGrid.getPage(1);
      return;
    }
    if (event.index === 3 && !this.showBillReport) {
        this.showBillReport = true;
        let fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 1);
        this.recipeListFilter.dateFromValue = fromDate;
        this.recipeListFilter.dateToValue = new Date();
        this.companyService.getItems(null).subscribe(d => {
        // this.companies = d;
        this.companiesReady = true;
        d.forEach( company => {
          if (company.businessType === this.globals.portalType) {
            this.companies.push(company)
          }
        });

        if (this.companies != null && this.companies.length > 0) {
            this.recipeListFilter.companyUid = this.companies[0].companyUid;
        }
      });
      return;
    }
  }

  ngAfterViewInit(): void {
    // FIX: Expression has changed after it was checked.
    // See https://github.com/angular/angular/issues/6005
    this.changeDetectionRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/monitoring/monitoring.component.ts